import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const Toast = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  background: var(--nd-black);
  border: 1px solid var(--nd-text-display);
  border-radius: 4px;
  padding: 12px 16px;
  font-family: 'Space Mono', monospace;
  font-size: 12px;
  letter-spacing: 0.04em;
  color: var(--nd-text-display);
  z-index: 9999;
  opacity: ${({ show }) => (show ? 1 : 0)};
  transform: translateY(${({ show }) => (show ? "0" : "16px")});
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: none;

  @media (max-width: 480px) {
    bottom: 80px; /* clear NextSectionButton FAB */
    right: 16px;
    left: 16px;
    text-align: center;
  }
`;

const XpToast = () => {
  const [msg, setMsg] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => {
    const onAward = (e) => {
      const { awarded, newBadges } = (e && e.detail) || {};
      if (!awarded) return;
      const bonus =
        newBadges && newBadges.length
          ? ` · badge: ${newBadges[0]}`
          : "";
      setMsg(`+${awarded} XP${bonus}`);
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setMsg(null), 2500);
    };
    window.addEventListener("gami:awarded", onAward);
    return () => {
      window.removeEventListener("gami:awarded", onAward);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <Toast show={!!msg} role="status" aria-live="polite">
      {msg}
    </Toast>
  );
};

export default XpToast;
